import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import CookieJar from '@/utilities/cookieJar';

const routes = [

  {
    path: '/',
    redirect: { name: 'Login' }
  },
  {
    path: '/login',
    component: () => import('../pages/login.vue'),
    name: 'Login'
  },
  {
    path: '/register',
    component: () => import('../pages/register.vue'),
    name: 'Register'
  },
  {
    path: '/verification-check/:checkType',
    component: () => import('../pages/verification-check.vue'),
    props: true,
    name: 'VerificationCheck'
  },
  {
    path: '/verify',
    component: () => import('../pages/verify.vue'),
    name: 'VerifyUser'
  },
  {
    path: '/resend-verification',
    component: () => import('../pages/resend-verification.vue'),
    name: 'ResendVerification'
  },
  {
    path: '/dashboard',
    component: () => import('../pages/dashboard.vue'),
    name: 'Dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stage-one',
    component: () => import('../pages/stage.vue'),
    name: 'StageOne',
    redirect: { name: 'ContactDetailsEOI' },
    meta: {
      applicationType: 'eoi',
      steps: 'stageOneSteps',
      stageName: 'Expression of Interest Application',
      confirmationPage: 'EOIConfirmation',
      requiresAuth: true
    },
    children: [
      {
        path: 'contact-details',
        component: () => import('../pages/stage-one/contact-details.vue'),
        name: 'ContactDetailsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'business-location',
        component: () => import('../pages/stage-one/business-location.vue'),
        name: 'BusinessLocation',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'business-details',
        component: () => import('../pages/stage-one/business-details.vue'),
        name: 'BusinessDetailsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      },
      {
        path: 'declarations',
        component: () => import('../pages/stage-one/declarations.vue'),
        name: 'DeclarationsEOI',
        meta: {
          requiresAuth: true,
          requiresEOI: true
        }
      }
    ]
  },
  // {
  //   path: '/stage-two/large',
  //   component: () => import('../pages/stage.vue'),
  //   name: 'StageTwoLarge',
  //   redirect: { name: 'CreditSafeDeclaration' },
  //   meta: {
  //     applicationType: 'application',
  //     steps: 'stageTwoStepsLarge',
  //     stageName: 'Application',
  //     confirmationPage: 'ApplicationConfirmation',
  //     requiresAuth: true,
  //     requiresApplication: true
  //   },
  //   children: [
  //     {
  //       path: 'creditsafe-declaration',
  //       component: () => import('../pages/stage-two/large/creditsafe-declaration.vue'),
  //       name: 'CreditSafeDeclaration',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //       }
  //     },
  //     {
  //       path: 'business-details',
  //       component: () => import('../pages/stage-two/large/business-details.vue'),
  //       name: 'BusinessDetails',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //       }
  //     },
  //     {
  //       path: 'contact-details',
  //       component: () => import('../pages/stage-two/large/contact-details.vue'),
  //       name: 'ContactDetails',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'directors',
  //       component: () => import('../pages/stage-two/large/directors.vue'),
  //       name: 'Directors',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'shareholders',
  //       component: () => import('../pages/stage-two/large/shareholders.vue'),
  //       name: 'Shareholders',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'project-details-one',
  //       component: () => import('../pages/stage-two/large/project-details-1.vue'),
  //       name: 'ProjectDetailsOne',
  //       meta: {
  //        requiresAuth: true,
  //        requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'project-details-two',
  //       component: () => import('../pages/stage-two/large/project-details-2.vue'),
  //       name: 'ProjectDetailsTwo',
  //       meta: {
  //        requiresAuth: true,
  //        requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'market-information',
  //       component: () => import('../pages/stage-two/large/market-information.vue'),
  //       name: 'MarketInformation',
  //       meta: {
  //        requiresAuth: true,
  //        requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'project-impacts',
  //       component: () => import('../pages/stage-two/large/project-impacts.vue'),
  //       name: 'ProjectImpacts',
  //       meta: {
  //        requiresAuth: true,
  //        requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'payment-details',
  //       component: () => import('../pages/stage-two/large/payment-details.vue'),
  //       name: 'PaymentDetails',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'additional-documents',
  //       component: () => import('../pages/stage-two/large/additional-documents.vue'),
  //       name: 'AdditionalDocuments',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     },
  //     {
  //       path: 'declarations',
  //       component: () => import('../pages/stage-two/large/declarations.vue'),
  //       name: 'Declarations',
  //       meta: {
  //         requiresAuth: true,
  //         requiresApplication: true
  //        }
  //     }
  //   ]
  // },
  {
    path: '/stage-two/small',
    component: () => import('../pages/stage.vue'),
    name: 'StageTwoSmall',
    redirect: { name: 'CreditSafeDeclarationSmall' },
    meta: {
      applicationType: 'application',
      steps: 'stageTwoStepsSmall',
      stageName: 'Application',
      confirmationPage: 'ApplicationConfirmation',
      requiresAuth: true,
      requiresApplication: true
    },
    children: [
      {
        path: 'creditsafe-declaration',
        component: () => import('../pages/stage-two/small/creditsafe-declaration.vue'),
        name: 'CreditSafeDeclarationSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
        }
      },
      {
        path: 'business-details',
        component: () => import('../pages/stage-two/small/business-details.vue'),
        name: 'BusinessDetailsSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
        }
      },
      {
        path: 'contact-details',
        component: () => import('../pages/stage-two/small/contact-details.vue'),
        name: 'ContactDetailsSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'directors',
        component: () => import('../pages/stage-two/small/directors.vue'),
        name: 'DirectorsSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'project-details-one',
        component: () => import('../pages/stage-two/small/project-details-1.vue'),
        name: 'ProjectDetailsOneSmall',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'project-details-two',
        component: () => import('../pages/stage-two/small/project-details-2.vue'),
        name: 'ProjectDetailsTwoSmall',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'business-finances',
        component: () => import('../pages/stage-two/small/business-finances.vue'),
        name: 'BusinessFinancesSmall',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'market-information',
        component: () => import('../pages/stage-two/small/market-information.vue'),
        name: 'MarketInformationSmall',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'project-impacts',
        component: () => import('../pages/stage-two/small/project-impacts.vue'),
        name: 'ProjectImpactsSmall',
        meta: {
         requiresAuth: true,
         requiresApplication: true
         }
      },
      {
        path: 'payment-details',
        component: () => import('../pages/stage-two/small/payment-details.vue'),
        name: 'PaymentDetailsSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      },
      {
        path: 'declarations',
        component: () => import('../pages/stage-two/small/declarations.vue'),
        name: 'DeclarationsSmall',
        meta: {
          requiresAuth: true,
          requiresApplication: true
         }
      }
    ]
  },
  {
    path: '/stage-one/confirmation',
    component: () => import('../pages/eoi-confirmation.vue'),
    name: 'EOIConfirmation',
    meta: {
      requiresAuth: true
     }
    },
  {
    path: '/stage-two/confirmation',
    component: () => import('../pages/application-confirmation.vue'),
    name: 'ApplicationConfirmation',
    meta: {
      requiresAuth: true
     }
  },
  {
    path: '/claim',
    component: () => import('../pages/stage.vue'),
    name: 'Claim',
    redirect: { name: 'ClaimDetails' },
    props: true,
    meta: {
      applicationType: 'claim',
      steps: 'claimSteps',
      stageName: 'Claim',
      confirmationPage: 'ClaimConfirmation',
      requiresAuth: true
    },
    children: [
      {
        path: 'claim-details/:size/:claimId',
        component: () => import('../pages/claim/claim-details.vue'),
        name: 'ClaimDetails',
        props: true,
        meta: {
          requiresAuth: true,
          requiresClaims: true
        }
      }

    ]
  },
  {
    path: '/claim/confirmation',
    component: () => import('../pages/claim-confirmation.vue'),
    name: 'ClaimConfirmation',
    meta: {
      requiresAuth: true
     }
  },
  {
    path: '/documents/:stage/:applicationSize',
    component: () => import('../pages/document-management.vue'),
    name: 'DocumentManagement',
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/privacy-policy',
    component: () => import('../pages/privacy-policy.vue'),
    name: 'PrivacyPolicy'
  },
  {
    path: '/close-down',
    name: 'CloseDown',
    component: () => import('../pages/close-down.vue')
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../pages/server-error.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('../pages/faq.vue')
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../pages/forgot-password.vue')
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../pages/reset-password.vue'),
    beforeEnter: (to, from) => {
      if (!to.query.token || !to.query.email) {
        router.push({ name: 'Login' });
      }
    }
  },
  {
    path: '/:catchAll(.*)',
    name: 'Error',
    component: () => import('../pages/not-found.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresEOI) && !store.getters['settings/getEoiDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else if (to.matched.some(record => record.meta.requiresApplication) && !store.getters['settings/getAppDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else if (to.matched.some(record => record.meta.requiresClaims) && !store.getters['settings/getClaimsDownloaded']) {
    router.push({ name: 'Dashboard' });
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['auth/isAuthenticated']) {
      next();
    } else {
      // nothing in the store, so lets check cookies
      const accessToken = CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}access_token`);
      const refreshToken = CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`);
      if (!accessToken) {
        // access token is invalid, lets check the refresh token
        if (!refreshToken) {
          // no valid tokens, redirect to login
          next({ name: 'Login' });
        } else {
          store.dispatch('auth/redeemToken', {
            refreshtoken: refreshToken,
            businessunit: process.env.VUE_APP_BUSINESS_UNIT
          }).then(() => {
            next();
          }).catch(() => {
            next({ name: 'Login' });
          });
        }
      } else {
        store.dispatch('auth/updateAuth', {
          accessToken,
          refreshToken
        }).then(() => {
          next();
        });
      }
    }
  } else {
    next();
  }
});

export default router;
